import "core-js/modules/es.number.constructor.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { toRefs, computed } from 'vue';
/** ui组件库 */
import { MessagePlugin as message } from 'tdesign-vue-next';
/** 接口 */
import { delGroup } from '@/api/index-fu.js';
export default {
  __name: 'deleteDialog',
  props: {
    deleteVisible: {
      // 删除弹窗显隐
      type: Boolean,
      default: false
    },
    teamId: {
      // 小组id
      type: Number,
      default: null
    }
  },
  emits: ['closeDeleteDialog', 'refreshGroupedList'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /** 组合式api */
    var props = __props;
    var _toRefs = toRefs(props),
      teamId = _toRefs.teamId;
    var emit = __emit;
    var visible = computed(function () {
      return props.deleteVisible;
    });

    /** 初始化相关 */

    /** 事件相关 */
    /**
     * 关闭弹窗
     */
    var closeDeleteDialog = function closeDeleteDialog() {
      emit('closeDeleteDialog');
    };

    /**
     * 确认
     */
    var sureDel = function sureDel() {
      delGroup(teamId.value).then(function (res) {
        if (res.data.code === 0) {
          message.success('删除成功');
          emit('refreshGroupedList');
          emit('closeDeleteDialog');
        }
      });
    };
    return function (_ctx, _cache) {
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        header: "删除小组",
        body: "是否确认删除小组？",
        confirmBtn: "删除",
        onClose: closeDeleteDialog,
        onConfirm: sureDel
      }, null, 8, ["visible"]);
    };
  }
};